<div *ngIf="itemsCount>1" class="history-revisions">
  <span class="history-revisions-dropdown Auto_Dropdown_Revisions" (click)="togglePanel($event)" #toggle>
      {{dropdownTitle}}
      <i class="icon__expand"></i>
  </span>

  <section class="history-revisions-panel"
           (clickOutside)="togglePanel($event,false)"
           (window:resize)="positionPanel($event,false)"
           [ngClass]="{'open':panelState}" #panel>

    <section class="history-revisions-header">
      <h3>{{itemsCount}} {{itemTypeText}}{{(itemsCount)==1?'':'s'}}</h3>
    </section>
<!--    <gen-overlay-loader [showOverlay]="false" *ngIf="!loaded"></gen-overlay-loader>-->
    <gen-history-table *ngIf="panelState"
                       [historyData]="historyDataFormalize"
                       [columnsToDisplay]="columnsToDisplay"
                       [currentRevisionId]="currentRevisionId"
                       (historyRowClick)="rowClick($event)">
    </gen-history-table>
    <section class="history-revisions-footer">
      <gen-history-actions *ngIf="actions != null"
        [actions] = "actions">
      </gen-history-actions>
    </section>
  </section>
</div>
